/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */

//
// What is this:
//
// Doncaster are launching a Maitre D program for the launch of their new
// dining precinct. This page is designed to be run on an iPad in a controlled
// environment.
//

import React, { FunctionComponent, useEffect, useState } from 'react'

import { Heading, Paragraph } from '@scentregroup/ui'
import { CallToAction as CallToActionModel } from './store'
import CallToAction from './call-to-action'
import Layout from './layout'
import StoreSummary from './store-summary'
import withDiningStores from './with-dining-stores'
import StoreDetail from './store-detail'

import styles from './index.module.scss'

const RESET_TIMEOUT = 30000

interface DoncasterMaitreDProps {
  stores: any[]
}

const DoncasterMaitreD: FunctionComponent<DoncasterMaitreDProps> = ({
  stores,
}) => {
  const [store, setStore] = useState(undefined)
  const [lastInteraction, setLastInteraction] = useState(Date.now())
  const [action, setAction] = useState(undefined)
  useEffect(() => {
    const r = setInterval(() => {
      if (Date.now() - lastInteraction > RESET_TIMEOUT) {
        setStore(undefined)
        setAction(undefined)
        setLastInteraction(Date.now())
      }
    }, RESET_TIMEOUT)
    return () => clearInterval(r)
  })

  if (!stores) {
    return null
  }

  const home = (): void => {
    setStore(undefined)
    setAction(undefined)
    setLastInteraction(Date.now())
  }
  const interact = (f: (val: any) => void, val: any): void => {
    setLastInteraction(Date.now())
    f(val)
  }

  if (store) {
    return (
      <Layout showBack onBackClicked={home}>
        <StoreDetail
          store={store!}
          triggerAction={(callToAction: CallToActionModel) =>
            interact(setAction, callToAction)
          }
        />
        <CallToAction action={action} />
      </Layout>
    )
  } else {
    return (
      <Layout showBack={false} onBackClicked={() => {}}>
        <div className={styles.StoreSelection}>
          <div className={styles.angle} />
          <Heading className={styles.heading}>
            Welcome to Westfield Doncaster dining
          </Heading>
          <div className={styles.Overview}>
            <Paragraph type="large">
              Choose your favourite restaurant to see menus and online bookings
            </Paragraph>
            <section className={styles.Stores}>
              {stores.map(s => (
                <StoreSummary
                  key={s.id}
                  store={s}
                  onClick={() => setStore(s)}
                />
              ))}
            </section>
          </div>
        </div>
      </Layout>
    )
  }
}

export default withDiningStores(DoncasterMaitreD as any)
